"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Technology = exports.MobileNetworkCode = exports.MobileCountryCode = void 0;
const effect_1 = require("effect");
// Note: Exports in this file are exported directly from the index.
const NAMESPACE = 'Network.Cellular';
exports.MobileCountryCode = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 999)).annotations({
    identifier: `${NAMESPACE}.MobileCountryCode`,
});
exports.MobileNetworkCode = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 999)).annotations({
    identifier: `${NAMESPACE}.MobileNetworkCode`,
});
exports.Technology = effect_1.Schema.Literal('gsm', // 2G
'cdma', // 2G
'wcdma', // 3G
'lte', // 4G
'nr').annotations({
    identifier: `${NAMESPACE}.Technology`,
});
//# sourceMappingURL=common.js.map